export default __webpack_public_path__ + "static/media/hora-examen.1a0373ce.svg";